import { useEffect, useRef, useState } from "react"
import { ActiveMask, FlexInner, StyledSwitch, SwitchOption } from "./styled"

export interface IRoundedSwitchOption {
  label: string
  value: string
}

const RoundedSwitch = ({
  options,
  value,
  onChange,
  disabled = false,
  fullWidth = false,
}: {
  options: IRoundedSwitchOption[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  fullWidth?: boolean
}) => {
  const activeIndex = options.findIndex((option) => option.value === value)
  const optionRefs = useRef<(HTMLDivElement | null)[]>([])

  const [maskStyle, setMaskStyle] = useState({ width: 0, left: 0 })
  const [hasTransition, setHasTransition] = useState(false)

  useEffect(() => {
    const activeRef = optionRefs.current[activeIndex]

    if (activeRef) {
      const { width } = activeRef.getBoundingClientRect()

      let left = 0
      for (let i = 0; i < activeIndex; i++) {
        const ref = optionRefs.current[i]
        if (ref) {
          left += ref.getBoundingClientRect().width
        }
      }

      setMaskStyle({ width, left })
    }

    const timer = setTimeout(() => {
      setHasTransition(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [activeIndex])

  return (
    <StyledSwitch $fullWidth={fullWidth}>
      <FlexInner $fullWidth={fullWidth}>
        <ActiveMask
          $width={maskStyle.width}
          $left={maskStyle.left}
          $hasTransition={hasTransition}
        />

        {options.map((option, optionIndex) => (
          <SwitchOption
            ref={(el) => {
              optionRefs.current[optionIndex] = el
            }}
            $disabled={disabled}
            $isActive={activeIndex === optionIndex}
            $fullWidth={fullWidth}
            key={option.value}
            onClick={() => {
              if (!disabled) {
                onChange(option.value)
              }
            }}
          >
            {option.label}
          </SwitchOption>
        ))}
      </FlexInner>
    </StyledSwitch>
  )
}

export default RoundedSwitch
